import React from "react";
import "./OutlineButton.css";

export default function OutlineButton({
  title,
  onClick,
  loading = false,
  disabled = false,
  type = "button",
  fullWidth = false,   // ✅ تمام عرض
  icon = null          // ✅ آیکن اختیاری
}) {
  return (
    <button
      type={type}
      className={`outline-button
                  ${loading ? "is-loading" : ""}
                  ${fullWidth ? "full-width" : ""}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <span className="spinner"></span>
      ) : (
        <>
          {icon && <span className="btn-icon">{icon}</span>}
          <span className="btn-title">{title}</span>
        </>
      )}
    </button>
  );
}
